var map = {
	"./QRCode.png": "857d",
	"./RDS1.png": "aa34",
	"./SLB.png": "debd",
	"./VM.png": "a3d1",
	"./bank.png": "68a5",
	"./bank1.jpg": "0e38",
	"./bank2.jpg": "007e",
	"./bank_2.png": "393c",
	"./bank_3.png": "dcaa",
	"./bao.png": "62f4",
	"./general-resource-bwPackage.png": "dee8",
	"./general-resource-disk.png": "5d09",
	"./general-resource-group.png": "de5c",
	"./general-resource-ip.png": "23b5",
	"./general-resource-mirror.png": "e1e8",
	"./general-resource-nat.png": "e44b",
	"./general-resource-rds.png": "e5d7",
	"./general-resource-slb.png": "c1d3",
	"./general-resource-snap.png": "b9da",
	"./general-resource-vif.png": "c233",
	"./general-resource-vm.png": "c7a8",
	"./general-resource-vpc.png": "f8e8",
	"./general-user.png": "bdf3",
	"./lkl(1).png": "0570",
	"./lkl.png": "ea4c",
	"./load-sm.gif": "22b6",
	"./loading.gif": "cf59",
	"./login-loading.gif": "ae52",
	"./logo.png": "51c1",
	"./nat.png": "daf4",
	"./paypal.png": "2fda",
	"./price-loading.gif": "62d2",
	"./remitaccountphoto.jpg": "b5e1",
	"./route.png": "06c8",
	"./switch.png": "1560",
	"./wchart.png": "aca9",
	"./webLogo.png": "9042"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9519";